import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class AssessmentService {
  constructor(private apiService: ApiService) {}

  private apiURL = `${environment.apiLocations.patient}/assessment`;

  getWoundQuestions(
    woundType: number,
    ulcerWoundTypeId?: string | null,
  ): Observable<any> {
    const ulcerWoundTypeQuery = ulcerWoundTypeId
      ? `&UlcerWoundTypeId=${encodeURIComponent(ulcerWoundTypeId)}`
      : '';
    const url = `${this.apiURL}/getListAssessmentQuestion?PageIndex=0&PageSize=100&WoundType=${woundType}${ulcerWoundTypeQuery}`;
    return this.apiService.get<any>(url);
  }
}
